import React from 'react'
import cn from 'classnames'
import WithTooltip from 'components/shared/WithTooltip'
import styles from 'components/panels/stream-order.module.scss'
import { ARTIST_ORDERS } from './radioArtistsModel'
import { setMusicPanelView, useMusicPanelView } from './musicPanelView'

const ORDER_ICONS = { hot: 'fa fa-fire', top: 'fa fa-arrow-up fa-large', time: 'fa fa-clock-o' }

// The Artists order row, in the shared stream-order look: Hot / Top / New by
// radio upvalue. It sits in the Music header and drives the Artists list.
export default function ArtistsOrder({ panelId }: { panelId: string }) {
    const { order } = useMusicPanelView(panelId)

    return (
        <div className={styles.streamOrderComp}>
            <div className={styles.orderBtnContainer}>
                {ARTIST_ORDERS.map(option => (
                    <div key={option.key}>
                        <WithTooltip tip={option.tip}>
                            <button
                                type="button"
                                style={{ fontFamily: 'inherit', cursor: 'pointer' }}
                                aria-pressed={order === option.key}
                                className={cn(
                                    styles.orderBtn,
                                    order === option.key && styles.selected,
                                )}
                                onClick={ev => {
                                    ev.stopPropagation()
                                    ev.preventDefault()
                                    setMusicPanelView(panelId, { order: option.key })
                                }}
                            >
                                <i className={ORDER_ICONS[option.key]} />
                                <span className={styles.orderLabel}>{option.label}</span>
                            </button>
                        </WithTooltip>
                    </div>
                ))}
            </div>
        </div>
    )
}
